import { Button } from 'antd';
import React, { useContext, useEffect } from 'react';
import { apiClient } from '../../utils';
import { UserContext } from '../contexts';

export function LogoutPage() {
  const { setUser } = useContext(UserContext);
  
  const startLogin = () => {
    const url = (process.env.REACT_APP_KLT_BASE_API_URL || window.location.protocol + '//' + window.location.host) + '/login';
    window.location.href = url;
  };

  useEffect(() => {
    apiClient
      .get('logout')
      .then(() => {
        setUser(undefined);
      })
      .catch(() => {
        setUser(undefined);
      });
  }, [setUser]);

  return (
    <div style={{ padding: '15rem 0', textAlign: 'center' }}>
      <h1>Çıkış yaptınız!</h1>
      <h3>Uygulamadaki oturumunuz sonra erdi.</h3>
      <Button type="default" style={{ marginTop: '3rem' }} onClick={startLogin}>
        Tekrar giriş yap
      </Button>
    </div>
  );
}
